/* eslint-disable */
import { achievementService } from '../services/achievementService';

// Centralized achievement trigger utility
export const achievementTriggers = {
  // Movie/Show interactions
  async markWatched(userId, movieId, metadata = {}) {
    return await achievementService.checkAchievements(userId, 'mark_watched', {
      movieId,
      watchDate: new Date().toISOString(),
      ...metadata
    });
  },

  async submitReview(userId, movieId, rating, reviewLength) {
    return await achievementService.checkAchievements(userId, 'submit_review', {
      movieId,
      rating,
      reviewLength,
      timestamp: new Date().toISOString()
    });
  },

  async addToWatchlist(userId, movieId) {
    return await achievementService.checkAchievements(userId, 'add_to_watchlist', {
      movieId,
      timestamp: new Date().toISOString()
    });
  },

  // Social interactions
  async followUser(userId, followedUserId) {
    return await achievementService.checkAchievements(userId, 'follow_user', {
      followedUserId,
      timestamp: new Date().toISOString()
    });
  },

  async createPost(userId, postType, content) {
    return await achievementService.checkAchievements(userId, 'create_post', {
      postType,
      contentLength: content?.length || 0,
      timestamp: new Date().toISOString()
    });
  },

  async likePost(userId, postId, authorId) {
    return await achievementService.checkAchievements(userId, 'like_post', {
      postId,
      authorId,
      timestamp: new Date().toISOString()
    });
  },

  // User engagement
  async dailyLogin(userId) {
    return await achievementService.checkAchievements(userId, 'daily_login', {
      loginDate: new Date().toISOString().split('T')[0],
      timestamp: new Date().toISOString()
    });
  },

  async shareContent(userId, contentType, contentId) {
    return await achievementService.checkAchievements(userId, 'share_content', {
      contentType,
      contentId,
      timestamp: new Date().toISOString()
    });
  }
};